import { ComponentProps, FC } from "react";

import { cn } from "@/utils/tailwind";

export const RmSkeleton: FC<ComponentProps<"div">> = ({
  className,
  ...props
}) => {
  return (
    <div
      data-slot="skeleton"
      className={cn("animate-pulse rounded-md bg-accent", className)}
      {...props}
    />
  );
};
